import { ButtonBase } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { CarWashIcon, ArrowRightIcon } from '@ocx/ui-icons';
import { ListSelector } from '@ocx-app/hooks/useListController';
import { IStoreCarWashOption } from '@ocx-app/modules/stores/types';
import { useCarWashSelectorPopup, CarWashSelectorPopup } from '@ocx-app/components/modals';

import { messages } from '../../../pay-at-pump.messages';

type CarWashSelectorProps = {
  carWashListController: ListSelector<IStoreCarWashOption>;
};

export const CarWashSelector = ({ carWashListController }: CarWashSelectorProps) => {
  const carWashSelectorPopup = useCarWashSelectorPopup();
  const { selectedListItem } = carWashListController;

  return (
    <>
      <ButtonBase
        sx={{
          backgroundColor: selectedListItem ? 'primary.main' : 'action.selected',
          color: selectedListItem ? 'primary.contrastText' : 'text.primary',
          p: SizingMultiplier.md,
          minHeight: 64,
          borderRadius: 2,
        }}
        onClick={() => carWashSelectorPopup.show()}>
        <CarWashIcon sx={{ mr: SizingMultiplier.sm }} />
        <Typography component="span" textAlign="left">
          {selectedListItem?.name || <FormattedMessage {...messages.payAtPumpAddCarWashButtonText} />}
        </Typography>
        {selectedListItem && <ArrowRightIcon sx={{ ml: SizingMultiplier.sm }} />}
      </ButtonBase>
      <CarWashSelectorPopup id={carWashSelectorPopup.id} carWashListController={carWashListController} />
    </>
  );
};
